import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import RedemptionDetailCpt from '../components/RedemptionDetailCpt';
export default {
  components: {
    PageNavBackLayoutCpt,
    RedemptionDetailCpt
  },
  data() {
    return {
      isPullRefreshing: false
    };
  },
  methods: {
    onPullRefresh() {
      this.$refs.RedemptionDetail.init(this.isPullRefreshing);
      this.isPullRefreshing = false;
    }
  }
};